import React from 'react'

const About = () => {
  return (
    <div>
      <h2 className="h-screen container bg-stone-200 text-black font-bold flex pt-8 justify-center text-2xl ">
        This is About Us
      </h2>
    </div>
  )
}

export default About
